import { useEffect } from 'react';
import { parseProviderFromState } from '../utils/socialAuthWeb';

export default function SocialCallbackPage() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const stateParam = url.searchParams.get('state');
    const error = url.searchParams.get('error');
    const provider = parseProviderFromState(stateParam);

    const nextUrl = new URL('/auth/social/complete', window.location.origin);
    nextUrl.searchParams.set('provider', provider);
    if (code) nextUrl.searchParams.set('code', code);
    if (stateParam) nextUrl.searchParams.set('state', stateParam);
    if (error) nextUrl.searchParams.set('error', error);

    // 항상 complete 페이지로 앱 복귀 (다이어그램대로)
    const deepLink = `pocapan://webview?url=${encodeURIComponent(nextUrl.toString())}`;
    window.location.replace(deepLink);
  }, []);

  return null;
}
